//import packages from node modules
import React from "react"
import PropTypes from "prop-types"

//import shared components
import Tooltip from "../tooltip";

const Ellipsis = (props) => {
    const {isActive,children,className,format,tooltip} = props
    const renderTooltip = () => {
        return (
            <div className={'of-ellipsis__format'}>
                <Tooltip className={`of-ellipsis__tooltip`} description={tooltip} button={format}/>
            </div>
        )
    }
    const renderContent = () => {
        if(isActive){
            return renderTooltip()
        }
        return (
            <div className={`of-ellipsis__content`}>
                {children}
            </div>
        )
    }

    return (
        <div className={`of-ellipsis${className?' '+className:''}`}>
            {renderContent()}
        </div>
    )
}

Ellipsis.propTypes = {
    isActive: PropTypes.bool,
    format: PropTypes.any,
    className: PropTypes.string,
    tooltip: PropTypes.string,
    children: PropTypes.any
}

export default Ellipsis